import PropTypes from 'prop-types';

import { MockedRadio, FilterRow, Radio, Title } from './FilterRow.styled';

export function SortFilterRow({ title, value, onSelect, selected, onClick }) {
  const handleClick = e => {
    onSelect(value);

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <FilterRow htmlFor={title}>
      <Radio
        name="sortFilter"
        id={title}
        onChange={handleClick}
        checked={selected}
      />
      <Title>{title}</Title>
      <MockedRadio selected={selected} />
    </FilterRow>
  );
}

SortFilterRow.defaultProps = {
  onClick: undefined,
  selected: false,
};

SortFilterRow.propTypes = {
  onClick: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
